export default __webpack_public_path__ + "static/media/dressImg.a9985d6a.jpg";